export default __webpack_public_path__ + "static/Do-Align-buttons-bottom-right-40db7589526c9dc6b06bc08f7d0dae52de558489708dbceeb6b4d08323f1d740.png";